import styled from 'styled-components';
import { Section } from 'tno-core/dist/components/section';

export const IngestConfiguration = styled(Section)`
  .checkbox-label {
    font-weight: bold;
  }
`;
